export const EMPTY_WIDGET_DATA_IDS_CONTRACT = {
  base: 'empty-widget',
  title: 'title',
  icon: 'icon',
  subTitle: 'sub-title',
  docLink: 'link',
  primaryCTA: 'primary',
  secondaryCTA: 'secondary'
};
